import { request, METHOD } from '@/utils/request';
var BASE_URL = process.env.VUE_APP_API_BASE_URL;

/* 获取原产地信息数据列表（#185） */
export function getBrandList(data) {
  return request("".concat(BASE_URL) + "/brand/list", METHOD.GET, data, {
    headers: {
      'Content-Type': "application/x-www-form-urlencoded"
    }
  });
}
/*新增品牌信息数据（#186） */
export function addBrand(data) {
  return request("".concat(BASE_URL) + "/brand", METHOD.POST, data);
}
/* 获取品牌信息数据（#181） */
export function getBrandDetail(id) {
  return request("".concat(BASE_URL) + "/brand/" + id, METHOD.GET);
}

/* 更新品牌信息数据（#182） */
export function updateBrandInfo(data) {
  return request("".concat(BASE_URL) + "/brand", METHOD.PUT, data);
}

/* 更新品牌状态信息数据（#183） */
export function updateBrandStatus(data) {
  return request("".concat(BASE_URL) + "/brand/status", METHOD.PUT, data);
}
/* 删除品牌信息数据（#184） */
export function deleteBrand(id) {
  return request("".concat(BASE_URL) + "/brand/" + id, METHOD.DELETE);
}
export default {
  getBrandList: getBrandList,
  addBrand: addBrand,
  getBrandDetail: getBrandDetail,
  updateBrandInfo: updateBrandInfo,
  updateBrandStatus: updateBrandStatus,
  deleteBrand: deleteBrand
};